import React from 'react';

interface TaskSortProps {
    fill?: string;
}

export const TaskSort = ({ fill = '#818998' }: TaskSortProps) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4233_4199)">
                <g clipPath="url(#clip1_4233_4199)">
                    <path
                        d="M13.7313 3.73133L12 2V16H10.6667V2L8.95401 3.71267L8.01134 2.77L10.3907 0.390667C10.641 0.141194 10.98 0.00111062 11.3333 0.00111062C11.6867 0.00111062 12.0257 0.141194 12.276 0.390667L14.674 2.78867L13.7313 3.73133ZM5.33334 14V0H4.00001V14L2.27134 12.2713L1.32867 13.214L3.72401 15.6093C3.98401 15.8693 4.32534 15.9993 4.66667 15.9993C5.00801 15.9993 5.34934 15.8693 5.60934 15.6093L7.99201 13.2273L7.04934 12.2847L5.33334 14Z"
                        fill={fill}
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_4233_4199">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
                <clipPath id="clip1_4233_4199">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
